import React from 'react';
import AttentionMessageTypes from './AttentionMessageTypes';
import AttentionMessage, { AttentionMessageProps } from './AttentionMessage';

export type WarningMessageProps = Omit<AttentionMessageProps, 'type'>;
const WarningMessage = ({ ...rest }: WarningMessageProps): JSX.Element => {
    return <AttentionMessage type={AttentionMessageTypes.WARNING} {...rest} />;
};

export default WarningMessage;
